<div
  [id]="'mz-option__item' + value"
  class="mz-option__item"
  [class.mz-option__item--disabled]="disabled"
  data-cy="select-option-item"
  (click)="selectOption()">
  <ng-content></ng-content>
</div>
